import React, { useState } from "react";
import { Dialog, DialogActions, DialogTitle } from "@mui/material";
import { sendDataWithPost } from "../../../services/services";
import { showSuccessMsg } from "../../../utils/toast";
import { LoadingButton } from "@mui/lab";
import { styles } from "../../../utils/styles";

const DeleteQuickPayment = ({ data, queryPage, handleCloseDialog }) => {
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    if (loading) return;
    handleCloseDialog();
  }

  const handleSubmit = async () => {
    const payload = { merchant_quick_payment_id: data.id };
    const url = `merchant/terminal/delete_quick_payment/`;
    setLoading(true);

    await sendDataWithPost(url, payload, null, null, (res) => {
      showSuccessMsg(res.data?.detail);
      handleCloseDialog();
      queryPage();
    });
    setLoading(false);
  };

  return (
    <Dialog open={true} onClose={handleClose}>
      <DialogTitle>
        {`Are you sure you want to remove this Quick Payment?`}
      </DialogTitle>
      <DialogActions>
        <LoadingButton variant="outlined" onClick={handleClose} disabled={loading}>
          Cancel
        </LoadingButton>
        <LoadingButton variant="contained" onClick={handleSubmit} loading={loading} sx={{ ...styles.customButton }}>
          Submit
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteQuickPayment;
